import { selectAccessToProtectedRoutes } from '../store/auth/selectors';
import { Navigate, Outlet, useSearchParams } from 'react-router-dom';
import { useDispatch, useSelector } from '../store/store';
import { FC, useEffect } from 'react';
import { setConfirmJoinOrganizationModal, setInviteMemberToken } from '../store/workspace/slice';
import { setUserEmail } from '../store/signUp/slice';

export const ProtectedRoute: FC = () => {
    const dispatch = useDispatch();
    const hasAccess = useSelector(selectAccessToProtectedRoutes);
    const [params, setParams] = useSearchParams();
    const memberToken = params.get('token');
    const memberEmail = params.get('email');

    useEffect(() => {
        if (!hasAccess && memberToken) {
            dispatch(setConfirmJoinOrganizationModal(true));
            dispatch(setInviteMemberToken(memberToken));
            memberEmail && dispatch(setUserEmail(memberEmail));
        }
    }, []);

    return (hasAccess ? <Outlet /> : <Navigate to='/workspace' />);
};